import { motion } from "framer-motion"
import { AdChannel } from "~/ui-rtk/api/types/custom-attribution-enums"

interface ChannelSelectorProps {
  onChannelSelect: (channel: AdChannel) => void
  error?: string
  touched?: boolean
}

export function ChannelSelector({
  onChannelSelect,
  error,
  touched,
}: ChannelSelectorProps) {
  return (
    <motion.div
      key="channel-selection"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.15,
          ease: "easeInOut",
        },
      }}
      transition={{
        duration: 0.2,
        ease: "easeInOut",
      }}
      className="space-y-3 px-system-md mt-system-md"
    >
      <div className="text-lg font-semibold text-white mb-3">
        Select Channel
      </div>
      <div className="grid grid-cols-1 gap-2">
        {Object.values(AdChannel).map((channel, index) => (
          <motion.button
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.1,
                delay: index * 0.02,
              },
            }}
            transition={{
              duration: 0.15,
              delay: index * 0.05,
            }}
            key={channel}
            type="button"
            onClick={() => onChannelSelect(channel)}
            className="flex items-center gap-3 p-system-sm bg-system-blue-600/20 hover:bg-system-blue-600/30 rounded-md border border-system-blue-600/30 hover:border-system-blue-400/50 transition-all duration-200 text-left group"
          >
            <div className="w-8 h-8 rounded-md bg-system-blue-600/30 flex items-center justify-center group-hover:bg-system-blue-500/20 transition-colors">
              {channel === AdChannel.META && (
                <img
                  src="/assets/img/sources/meta.svg"
                  alt="Meta"
                  className="w-5 h-5"
                />
              )}
              {channel === AdChannel.TIKTOK && (
                <img
                  src="/assets/img/sources/tiktok.svg"
                  alt="TikTok"
                  className="w-5 h-5"
                />
              )}
              {channel === AdChannel.PINTEREST && (
                <img
                  src="/assets/img/sources/pinterest.svg"
                  alt="Pinterest"
                  className="w-5 h-5"
                />
              )}
              {channel === AdChannel.GOOGLE_ADS && (
                <img
                  src="/assets/img/sources/google_ads.png"
                  alt="Google Ads"
                  className="w-5 h-5 object-contain"
                />
              )}
              {channel === AdChannel.YOUTUBE && (
                <img
                  src="/assets/img/sources/youtube.svg"
                  alt="YouTube"
                  className="w-5 h-5"
                />
              )}
            </div>
            <div>
              <div className="text-white font-medium text-base">{channel}</div>
              <div className="text-sm text-system-gray-400">
                {channel === AdChannel.META && "Meta Ads Platform"}
                {channel === AdChannel.TIKTOK && "TikTok Ads Platform"}
                {channel === AdChannel.PINTEREST && "Pinterest Ads Platform"}
                {channel === AdChannel.GOOGLE_ADS && "Google Ads Platform"}
                {channel === AdChannel.YOUTUBE && "YouTube Ads Platform"}
              </div>
            </div>
          </motion.button>
        ))}
      </div>
      {error && touched && (
        <p className="text-red-400 text-base mt-2">{error}</p>
      )}
    </motion.div>
  )
}
